import { render, staticRenderFns } from "./SettingsPopup.vue?vue&type=template&id=7d4a32cc&"
import script from "./SettingsPopup.vue?vue&type=script&lang=js&"
export * from "./SettingsPopup.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports